import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { getSingleRequest } from "store/actions";
import Loader from "components/shared/Loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const ShowRequest = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { formatMessage, locale } = useIntl();

  const { loading, error, singleRequest } = useSelector(
    (state) => state.requests,
  );

  useEffect(() => {
    dispatch(getSingleRequest(id));
    // dispatch(getSection({ page: "contact", slug: id }));
  }, [dispatch, id]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form single-request">
        <div className="card job-details">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"showRequest"} />
            </h4>
          </div>
          <div className="card-body table-details--">
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td>الاسم</td>
                    <td>{singleRequest?.name} </td>
                  </tr>
                  <tr>
                    <td>الهاتف</td>
                    <td>{singleRequest?.phone}</td>
                  </tr>

                  <tr>
                    <td>البريد الإلكتروني</td>
                    <td>{singleRequest?.email}</td>
                  </tr>
                  <tr>
                    <td>تفاصيل الخادمة</td>
                    <td style={{ whiteSpace: "pre-wrap", lineHeight: "2" }}>
                      {singleRequest?.message}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowRequest;
